import React, { useState, useEffect } from 'react'

import { Tree, Input } from 'antd'
import './customTreeTransfer.css'

const CustomTreeTransfer = ({
  values = [], // All values that will be displayed
  expandedValues = [], // Starting values that will be displayed opened
  checkedValues = [], // Checked are values that equals true
  selectedValues = [], // Selected are values that was clicked but wasnt checked
  setSelectedStateValue, // State that will return the checked value to the top component/container
  label = '', // Text label on top of the component
  searchLabel = '',
  isDisabled = false, // Should disable all node content
  hideSearch = false
}) => {
  const [treeData, setTreeData] = useState([])
  const [treeDataBkp, setTreeDataBkp] = useState([])
  const [expandedKeys, setExpandedKeys] = useState([])
  const [checkedKeys, setCheckedKeys] = useState([])
  const [selectedKeys, setSelectedKeys] = useState([])
  const [autoExpandParent, setAutoExpandParent] = useState(true)
  const [labelData, setLabelData] = useState('')

  useEffect(() => {
    setTreeData(values)
    setExpandedKeys(expandedValues)
    setCheckedKeys(checkedValues)
    setSelectedKeys(selectedValues)
    setLabelData(label)
  }, [values])

  const onExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys)
    setAutoExpandParent(false)
  }

  const onCheck = (checkedKeys) => {
    setCheckedKeys(checkedKeys)
    setSelectedStateValue(checkedKeys)
  }

  const onSelect = (selectedKeys) => {
    setSelectedKeys(selectedKeys)
  }

  function onSearch(value) {
    if ((value === null || value === '') && treeDataBkp.length !== 0) {
      setTreeData(treeDataBkp)
      setTreeDataBkp([])
      return null
    }

    if (treeDataBkp.length === 0) {
      setTreeDataBkp(treeData)
    }

    const filteredTreeData = []
    treeData.filter((parentItem) => {
      if (parentItem.title.toUpperCase().includes(value.toUpperCase())) {
        filteredTreeData.push(parentItem)
      } else if (Array.isArray(parentItem.children)) {
        parentItem.children.forEach((childItem) => {
          if (childItem.title.toUpperCase().includes(value.toUpperCase())) {
            filteredTreeData.push(childItem)
          }
        })
      }
    })
    return setTreeData(filteredTreeData)
  }

  return (
    <>
      {!hideSearch && (
        <>
          {labelData}
          <Input.Search onSearch={onSearch} placeholder={searchLabel} />
        </>
      )}
      <Tree
        checkable
        onExpand={onExpand}
        expandedKeys={expandedKeys}
        autoExpandParent={autoExpandParent}
        onCheck={onCheck}
        checkedKeys={checkedKeys}
        onSelect={onSelect}
        selectedKeys={selectedKeys}
        treeData={treeData}
        disabled={isDisabled}
        className="ant-tree-wallet ant-card ant-card-bordered"
      />
    </>
  )
}

export default CustomTreeTransfer
